import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import Landing from "./pages/Landing";
import About from "./pages/About";
import GetInvolved from "./pages/GetInvolved";
import Stories from "./pages/Stories";
import EventsPublic from "./pages/EventsPublic";
import Contact from "./pages/Contact";
import PortalPreviewStub from "./pages/PortalPreview";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Unsubscribe from "./pages/Unsubscribe";
import Claim from "./pages/Claim";
import SupportPage from "./pages/Support";
import Donate from "./pages/Donate";
import DonateSuccess from "./pages/DonateSuccess";
import DonateCancel from "./pages/DonateCancel";
import PortalLayout from "./pages/portal/PortalLayout";
import Dashboard from "./pages/portal/Dashboard";
import Messaging from "./pages/portal/Messaging";
import Community from "./pages/portal/Community";
import Volunteer from "./pages/portal/Volunteer";
import Hospitals from "./pages/portal/Hospitals";
import Resources from "./pages/portal/Resources";
import Events from "./pages/portal/Events";
import SupportRequests from "./pages/portal/SupportRequests";
import Profile from "./pages/portal/Profile";
import AdminDonations from "./pages/portal/AdminDonations";
import AdminBuddies from "./pages/portal/AdminBuddies";
import Matches from "./pages/portal/Matches";
import Sessions from "./pages/portal/Sessions";
import SessionRoom from "./pages/portal/SessionRoom";
import HoldingView from "./pages/portal/HoldingView";
import BuddyConnectedAck from "./pages/portal/BuddyConnectedAck";
import NorthstarWelcome from "./pages/northstar/NorthstarWelcome";
import NorthstarShell from "./pages/northstar/NorthstarShell";
import AskNorthstar from "./pages/northstar/AskNorthstar";
import JourneyPlayer from "./pages/northstar/journeys/JourneyPlayer";
import JourneyHistory from "./pages/northstar/JourneyHistory";
import MyConnections from "./pages/northstar/connections/MyConnections";
import PersonalizationCenter from "./pages/northstar/PersonalizationCenter";
import DomainFoundation from "./pages/northstar/domain/DomainFoundation";
import LifecycleGuard from "./components/LifecycleGuard";
import Onboarding from "./pages/Onboarding";
import IntakeSpecialistDashboard from "./pages/IntakeSpecialist";
import BuddyApply from "./pages/BuddyApply";
import BuddyDashboard from "./pages/BuddyDashboard";
import EcosystemLayout from "./pages/ecosystem/EcosystemLayout";
import EcosystemOverview from "./pages/ecosystem/Overview";
import EcosystemEntities from "./pages/ecosystem/Entities";
import EcosystemNewEntity from "./pages/ecosystem/NewEntity";
import EcosystemEntityDetail from "./pages/ecosystem/EntityDetail";
import EcosystemReviewQueue from "./pages/ecosystem/ReviewQueue";
import EcosystemAuditLog from "./pages/ecosystem/AuditLog";
import EcosystemRelationships from "./pages/ecosystem/Relationships";
import VolunteerApply from "./pages/VolunteerApply";
import OrganizationApply from "./pages/OrganizationApply";
import MyApplications from "./pages/MyApplications";
import OpsLayout from "./pages/ops/OpsLayout";
import OpsDashboard from "./pages/ops/OpsDashboard";
import OnboardingQueue from "./pages/ops/OnboardingQueue";
import ApplicationDetail from "./pages/ops/ApplicationDetail";
import OpsVolunteers from "./pages/ops/Volunteers";
import OpsBuddies from "./pages/ops/BuddiesOps";
import OpsOrganizations, { OrganizationDetail as OpsOrgDetail } from "./pages/ops/Organizations";
import OpsOrgDetailV2 from "./pages/ops/OrganizationDetailV2";
import OpsStaff from "./pages/ops/Staff";
import OpsEmail from "./pages/ops/Email";
import OpsPeople from "./pages/ops/People";
import OpsPersonDetail from "./pages/ops/PersonDetail";
import OpsContentGovernance from "./pages/ops/ContentGovernance";
import OpsContentGovernanceDetail from "./pages/ops/ContentGovernanceDetail";
import OpsGeographicCoverage from "./pages/ops/GeographicCoverage";
import StaffAcceptInvitation from "./pages/StaffAcceptInvitation";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/events" element={<EventsPublic />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/portal-preview" element={<PortalPreviewStub />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/claim" element={<Claim />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/donate/success" element={<DonateSuccess />} />
          <Route path="/donate/cancel" element={<DonateCancel />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/intake" element={<IntakeSpecialistDashboard />} />
          <Route path="/intake/:intakeId" element={<IntakeSpecialistDashboard />} />
          <Route path="/buddy/apply" element={<BuddyApply />} />
          <Route path="/buddy/dashboard" element={<BuddyDashboard />} />
          <Route path="/volunteer/apply" element={<VolunteerApply />} />
          <Route path="/organization/apply" element={<OrganizationApply />} />
          <Route path="/partner/apply" element={<OrganizationApply />} />
          <Route path="/my-applications" element={<MyApplications />} />
          <Route path="/staff/accept-invitation" element={<StaffAcceptInvitation />} />
          <Route path="/portal/sessions/:sessionId/room" element={<SessionRoom />} />
          <Route path="/portal/connected" element={<BuddyConnectedAck />} />
          <Route path="/northstar" element={<NorthstarShell />} />
          <Route path="/northstar/welcome" element={<NorthstarWelcome />} />
          <Route path="/northstar/ask" element={<AskNorthstar />} />
          <Route path="/northstar/journeys/:journeyId" element={<JourneyPlayer />} />
          <Route
            path="/northstar/history"
            element={
              <LifecycleGuard>
                <JourneyHistory />
              </LifecycleGuard>
            }
          />
          <Route
            path="/northstar/connections"
            element={
              <LifecycleGuard>
                <MyConnections />
              </LifecycleGuard>
            }
          />
          <Route
            path="/northstar/settings/personalization"
            element={
              <LifecycleGuard>
                <PersonalizationCenter />
              </LifecycleGuard>
            }
          />
          <Route path="/northstar/domain/:key" element={<DomainFoundation />} />
          <Route path="/portal" element={<PortalLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="holding" element={<HoldingView />} />
            <Route path="messaging" element={<Messaging />} />
            <Route path="community" element={<Community />} />
            <Route path="volunteer" element={<Volunteer />} />
            <Route path="hospitals" element={<Hospitals />} />
            <Route path="resources" element={<Resources />} />
            <Route path="events" element={<Events />} />
            <Route path="support-requests" element={<SupportRequests />} />
            <Route path="profile" element={<Profile />} />
            <Route path="matches" element={<Matches />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="admin/donations" element={<AdminDonations />} />
            <Route path="admin/buddies" element={<AdminBuddies />} />
          </Route>
          <Route path="/ecosystem" element={<EcosystemLayout />}>
            <Route index element={<EcosystemOverview />} />
            <Route path="entities" element={<EcosystemEntities />} />
            <Route path="entities/new" element={<EcosystemNewEntity />} />
            <Route path="entities/:id" element={<EcosystemEntityDetail />} />
            <Route path="review" element={<EcosystemReviewQueue />} />
            <Route path="relationships" element={<EcosystemRelationships />} />
            <Route path="audit" element={<EcosystemAuditLog />} />
          </Route>
          <Route path="/ops" element={<OpsLayout />}>
            <Route index element={<OpsDashboard />} />
            <Route path="onboarding" element={<OnboardingQueue />} />
            <Route path="onboarding/:appId" element={<ApplicationDetail />} />
            <Route path="people" element={<OpsPeople />} />
            <Route path="people/:kind/:personId" element={<OpsPersonDetail />} />
            <Route path="volunteers" element={<OpsVolunteers />} />
            <Route path="buddies" element={<OpsBuddies />} />
            <Route path="organizations" element={<OpsOrganizations />} />
            <Route path="organizations/:orgId" element={<OpsOrgDetailV2 />} />
            <Route path="staff" element={<OpsStaff />} />
            <Route path="email" element={<OpsEmail />} />
            <Route path="content-governance" element={<OpsContentGovernance />} />
            <Route path="content-governance/:recordId" element={<OpsContentGovernanceDetail />} />
            <Route path="geographic-coverage" element={<OpsGeographicCoverage />} />
          </Route>
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
